import script from "./langSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./langSelect.vue?vue&type=script&setup=true&lang=js"

import "./langSelect.vue?vue&type=style&index=0&id=cd292f9e&lang=css"

const __exports__ = script;

export default __exports__